import Vue from 'vue'
import Router from 'vue-router'


// 解决点击当前菜单报错问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(Router);

const routes = [
    {
        path: '/',
        redirect:'/login'
    },
    {
        path: '/login',
        name: 'login',
        component: resolve => require(['@/views/login'],resolve),
    },
    {
      path: '/index',
      name: 'index',
      component: resolve => require(['@/views/index'],resolve),
   
      children:[        
        {
          path: '/categoryMaintenance',
          name: 'categoryMaintenance',
          component: resolve => require(['@/views/systemManagement/categoryMaintenance'],resolve),
          meta : {                     
            requireAuth:true      
          }
        },
        {
          path: '/brandMaintenance',
          name: 'brandMaintenance',
          component: resolve => require(['@/views/systemManagement/brandMaintenance'],resolve),
          meta : {                     
            requireAuth:true      
          }
        },
        {
          path: '/serviceProject',
          name: 'serviceProject',
          component: resolve => require(['@/views/systemManagement/serviceProject'],resolve),
          meta : {                     
            requireAuth:true      
          }
        },{
          path: '/shufflingManagement',
          name: 'shufflingManagement',
          component: resolve => require(['@/views/systemManagement/shufflingManagement'],resolve),
          meta : {                     
            requireAuth:true      
          }
        },{
          path: '/receivingInformation',
          name: 'receivingInformation',
          component: resolve => require(['@/views/systemManagement/receivingInformation'],resolve),
          meta : {                     
            requireAuth:true      
          }
        },{
          path: '/productCode',
          name: 'productCode',
          component: resolve => require(['@/views/systemManagement/productCode'],resolve),
          meta : {                     
            requireAuth:true      
          }
        },
        
        {
          path: '/underwriterManagement',
          name: 'underwriterManagement',
          component: resolve => require(['@/views/configurationManagement/underwriterManagement'],resolve),
          meta : {                     
            requireAuth:true      
          }
        },
        {
          path: '/underwriterProductManagement',
          name: 'underwriterProductManagement',
          component: resolve => require(['@/views/configurationManagement/underwriterProductManagement'],resolve),
          meta : {                     
            requireAuth:true      
          }
        },
        {
          path: '/salesManagement',
          name: 'salesManagement',
          component: resolve => require(['@/views/configurationManagement/salesManagement'],resolve),
          meta : {                     
            requireAuth:true      
          }
        },
        {
          path: '/personnelManagement',
          name: 'personnelManagement',
          component: resolve => require(['@/views/configurationManagement/personnelManagement'],resolve),
          meta : {                     
            requireAuth:true      
          }
        },
        {
          path: '/ewProductManagement',
          name: 'ewProductManagement',
          component: resolve => require(['@/views/configurationManagement/ewProductManagement'],resolve),
          meta : {                     
            requireAuth:true      
          }
        },
        {
          path: '/accountManagement',
          name: 'accountManagement',
          component: resolve => require(['@/views/configurationManagement/accountManagement'],resolve),
          meta : {                     
            requireAuth:true      
          }
        },

        {
          path: '/extendedPolicyManagement',
          name: 'extendedPolicyManagement',
          component: resolve => require(['@/views/documentsManagement/extendedPolicyManagement'],resolve),
          meta : {                     
            requireAuth:true      
          }
        },
        {
          path: '/receiptManagement',
          name: 'receiptManagement',
          component: resolve => require(['@/views/documentsManagement/receiptManagement'],resolve),
          meta : {                     
            requireAuth:true      
          }
        },
        {
          path: '/extendedWarrantyBills',
          name: 'extendedWarrantyBills',
          component: resolve => require(['@/views/statisticalAnalysis/extendedWarrantyBills'],resolve),
          meta : {                     
            requireAuth:true      
          }
        },      
        {
          path: '/salesBills',
          name: 'salesBills',
          component: resolve => require(['@/views/statisticalAnalysis/salesBills'],resolve),
          meta : {                     
            requireAuth:true      
          }
        },
        {
          path: '/acceptanceOrderAnalysis',
          name: 'acceptanceOrderAnalysis',
          component: resolve => require(['@/views/statisticalAnalysis/acceptanceOrderAnalysis'],resolve),
          meta : {                     
            requireAuth:true      
          }
        },
        {
          path: '/warrantySalesAnalysis',
          name: 'warrantySalesAnalysis',
          component: resolve => require(['@/views/statisticalAnalysis/warrantySalesAnalysis'],resolve),
          meta: {
            requireAuth: true
          }
        }
      ]
       
     
    },
   
]

const router = new Router({
    routes
 });
  
export default router;